export default "__VITE_ASSET__b6de9b8c__"